<template>
  <hm-content title="">
    <!-- <div class="mb20">
      <el-radio-group
        v-model="searchCondition.orderState"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="ruleForm">运费模板</el-radio-button>
        <el-radio-button label="areaRuleForm">配送区域模板</el-radio-button>
      </el-radio-group>
    </div> -->
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addStoreExpress"
          >新增运费模板</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.expressName"
          placeholder="模板名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          clearable
          placeholder="运费类型"
          v-model="searchCondition.feeCalcMode"
          class="mr10"
          filterable
        >
          <el-option
            :label="v.itemText"
            :value="v.itemValue"
            v-for="(v, i) in feeCalcModeList2"
            :key="i"
          ></el-option>
        </el-select>
        <!-- <el-cascader
          clearable
          class="mr10"
          ref="cascader"
          v-model="searchCondition.queryAreaCodeRegion"
          :props="queryProps"
          :show-all-levels="false"
          filterable
          size="small"
          placeholder="请选择收货地区"
        ></el-cascader> -->
        <el-button ref="btn" type="primary" size="small" @click="search"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <ul class="table-box">
        <li class="" v-for="(v, i) in list" :key="i">
          <div class="table-border flex flex-between item-center">
            <div class="flex flex-wrap flex-1">
              <div class="flex-1 expressName">
                {{ v.expressName }}
              </div>
              <div class="flex-1 flex item-center">
                最近编辑时间:{{ v.updateTime }}
              </div>
            </div>

            <div class="flex-1 flex flex-end">
              <el-button
                size="small"
                type="text"
                class="blue"
                @click="details(v)"
                >编辑</el-button
              >
              <el-button
                v-if="i !== 0 || v.expressName !== '默认运费模板'"
                @click="remove(v)"
                size="small"
                type="text"
                class="danger"
                >删除</el-button
              >
            </div>
          </div>
          <div class="table-content">
            <div v-if="v.defaultFeeMode === 'yes'" class="mt10 mb10">
              默认运费(除指定区域外)：
              <span class="blue">
                {{ v.lowerLimitNumber
                }}{{ v.feeCalcMode === "number" ? "件" : "KG" }} 内,邮费{{
                  v.lowerLimitExpressyFee
                }}元,每增加{{ v.overPerUnit
                }}{{ v.feeCalcMode === "number" ? "件" : "KG" }},运费增加{{
                  v.overPerPrice
                }}元
              </span>

              <span v-if="v.freeShipAmount !== null" class="blue"
                >,满 {{ v.freeShipAmount }} 元包邮。</span
              >
            </div>
            <div
              v-for="(j, index) in v.templateRelModels"
              :key="index"
              class="mb10 mt10"
              style="lineHeight:20px"
            >
              {{ j.codeNames }}:
              <span class="blue">
                {{ j.lowerLimitNumber
                }}{{ v.feeCalcMode === "number" ? "件" : "KG" }}内,邮费{{
                  j.lowerLimitAmount
                }}元,每增加{{ j.overPerUnit
                }}{{ v.feeCalcMode === "number" ? "件" : "KG" }},运费增加{{
                  j.overPerPrice
                }}元
              </span>
              <span v-if="j.freeShipAmount !== null" class="blue"
                >,满 {{ j.freeShipAmount }} 元包邮。</span
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      :before-close="handleCloseaa"
      width="1300px"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="110px"
      >
        <el-form-item label="模板名称" prop="expressName">
          <el-input
            :disabled="
              listType === 'edit' && ruleForm.expressName === '默认运费模板'
            "
            maxlength="20"
            clearable
            v-model="ruleForm.expressName"
            size="small"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="独立计费" prop="separateFeeMode">
          <el-switch
            v-model="ruleForm.separateFeeMode"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          >
          </el-switch>
          <div class="form-item-tip">
            开启后，运用该模板的商品将于订单内的其他商品分别计算费用
          </div>
        </el-form-item> -->
        <el-form-item
          label="计价方式"
          prop="feeCalcMode"
          v-if="feeCalcModeList2.length > 0"
        >
          <el-radio-group
            v-model="ruleForm.feeCalcMode"
            @change="feeCalcModeChange"
          >
            <el-radio

              v-for="(item, i) in feeCalcModeList2"
              :label="item.itemValue"
              :key="i"
              >{{ item.itemText }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="默认运费" prop="defaultFeeMode">
          <el-switch
            v-model="ruleForm.defaultFeeMode"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          >
          </el-switch>
          <div
            v-if="
              ruleForm.feeCalcMode !== '' &&
                ruleForm.feeCalcMode !== 'gratis' &&
                ruleForm.defaultFeeMode === 'yes'
            "
          >
            <!-- 按重量计算 -->
            <div v-if="ruleForm.feeCalcMode === 'weight'">
              <el-input
                @mousewheel.prevent.native
                clearable
                style="width:100px;"
                v-model="ruleForm.lowerLimitNumber"
                maxlength="8"
                @input="filterGt0OrFixed2('lowerLimitNumber')"
                size="small"
              ></el-input
              >KG内,邮费<el-input
                clearable
                @mousewheel.prevent.native
                style="width:100px;"
                maxlength="8"
                v-model="ruleForm.lowerLimitExpressyFee"
                @input="filterGt0OrFixed2('lowerLimitExpressyFee')"
                size="small"
              ></el-input
              >元,每增加<el-input
                @mousewheel.prevent.native
                clearable
                maxlength="8"
                style="width:100px;"
                v-model="ruleForm.overPerUnit"
                @input="filterGt0OrFixed2('overPerUnit')"
                size="small"
              ></el-input
              >KG,运费增加<el-input
                clearable
                maxlength="8"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerPrice"
                @input="filterGt0OrFixed2('overPerPrice')"
                size="small"
              ></el-input
              >元
            </div>
            <!-- 按件数收费 -->
            <div v-if="ruleForm.feeCalcMode === 'number'">
              <el-input
                clearable
                @mousewheel.prevent.native
                style="width:100px;"
                maxlength="8"
                v-model="ruleForm.lowerLimitNumber"
                @input="filterGt0('lowerLimitNumber')"
                size="small"
              ></el-input
              >件内,邮费<el-input
                clearable
                maxlength="8"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.lowerLimitExpressyFee"
                @input="filterGt0OrFixed2('lowerLimitExpressyFee')"
                size="small"
              ></el-input
              >元,每增加<el-input
                clearable
                maxlength="8"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerUnit"
                @input="filterGt0('overPerUnit')"
                size="small"
              ></el-input
              >件,运费增加<el-input
                clearable
                maxlength="8"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerPrice"
                @input="filterGt0OrFixed2('overPerPrice')"
                size="small"
              ></el-input
              >元
            </div>
            ,满<el-input
              clearable
              maxlength="8"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.freeShipAmount"
              @input="filterGt0OrFixed2('freeShipAmount')"
              size="small"
            ></el-input
            >元包邮.<span class="form-red">为空则不开启包邮！</span>
            <div class="form-item-tip">
              默认运费指除指定地区以外的运费
            </div>
          </div>
        </el-form-item>
        <el-form-item label="指定运费模式" prop="isArea">
          <el-radio-group
            v-model="ruleForm.isArea"
            size="small"
            @change="isAreaChange"
          >
            <el-radio label="no">指定省市运费</el-radio>
            <el-radio label="yes">指定区运费</el-radio>
          </el-radio-group>
          <el-tooltip
            class="item"
            effect="dark"
            content="指定区运费针对只配送个别区的商户（如只配送：'江汉区，江岸区'）"
            placement="top-start"
          >
            <i class="el-icon-question ml10" style="fontSize:20px"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item
          label="指定省市运费"
          prop="defaultExpress"
          v-if="ruleForm.isArea === 'no'"
        >
          <div class="flex item-center primary ">
            <div
              class="add-wrapper flex flex-center mr10 pointer"
              @click="addChild"
            >
              <span class="hmicon icon-hao "></span>
            </div>
            <span @click="addChild" class="pointer">添加指定省市运费</span>
          </div>
          <ul class="delive-box" v-if="ruleForm.templateRelModels.length">
            <li v-for="(v, i) in ruleForm.templateRelModels" :key="i">
              <div class="flex flex-between delive-heard">
                <div class="flex-1">
                  <span v-for="(j, index) in v.areaCodeRegion" :key="index">
                    {{ j.name }}
                  </span>
                </div>
                <div>
                  <el-button
                    size="small"
                    type="text"
                    class="blue"
                    @click="edit(v, i)"
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    class="danger"
                    @click="del(i, v)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="delive-content">
                <div v-if="ruleForm.feeCalcMode === 'weight'">
                  <el-input
                    @mousewheel.prevent.native
                    clearable
                    style="width:100px;"
                    v-model="v.lowerLimitNumber"
                    @input="filterGt0OrArrayFixed2(i, 'lowerLimitNumber')"
                    size="small"
                  ></el-input
                  >KG内,邮费<el-input
                    clearable
                    @mousewheel.prevent.native
                    style="width:100px;"
                    v-model="v.lowerLimitAmount"
                    @input="filterGt0OrArrayFixed2(i, 'lowerLimitAmount')"
                    size="small"
                  ></el-input
                  >元,每增加<el-input
                    @mousewheel.prevent.native
                    clearable
                    style="width:100px;"
                    v-model="v.overPerUnit"
                    @input="filterGt0OrArrayFixed2(i, 'overPerUnit')"
                    size="small"
                  ></el-input
                  >KG,运费增加<el-input
                    clearable
                    @mousewheel.prevent.native
                    style="width:100px;"
                    v-model="v.overPerPrice"
                    @input="filterGt0OrArrayFixed2(i, 'overPerPrice')"
                    size="small"
                  ></el-input
                  >元
                </div>
                <!-- 按件数收费 -->
                <div v-if="ruleForm.feeCalcMode === 'number'">
                  <el-input
                    clearable
                    maxlength="8"
                    @mousewheel.prevent.native
                    style="width:100px;"
                    v-model="v.lowerLimitNumber"
                    @input="filterGtArray0(i, 'lowerLimitNumber')"
                    size="small"
                  ></el-input
                  >件内,邮费<el-input
                    clearable
                    maxlength="8"
                    @mousewheel.prevent.native
                    style="width:100px;"
                    v-model="v.lowerLimitAmount"
                    @input="filterGt0OrArrayFixed2(i, 'lowerLimitAmount')"
                    size="small"
                  ></el-input
                  >元,每增加<el-input
                    clearable
                    maxlength="8"
                    @mousewheel.prevent.native
                    style="width:100px;"
                    v-model="v.overPerUnit"
                    @input="filterGtArray0(i, 'overPerUnit')"
                    size="small"
                  ></el-input
                  >件,运费增加<el-input
                    clearable
                    maxlength="8"
                    @mousewheel.prevent.native
                    style="width:100px;"
                    v-model="v.overPerPrice"
                    @input="filterGt0OrArrayFixed2(i, 'overPerPrice')"
                    size="small"
                  ></el-input
                  >元
                </div>
                ,满<el-input
                  clearable
                  maxlength="8"
                  @mousewheel.prevent.native
                  style="width:100px;"
                  v-model="v.freeShipAmount"
                  @input="filterGt0OrArrayFixed2(i, 'freeShipAmount')"
                  size="small"
                ></el-input
                >元包邮.<span class="form-red">为空则不开启包邮！</span>
              </div>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="指定区运费" prop="regionCodeList" v-else>
          <el-cascader
            clearable
            class="mr10"
            ref="cascader"
            v-model="queryAreaCodeRegion"
            :options="area"
            :props="queryProps"
            :show-all-levels="false"
            :change-on-select="changeOnSelect"
            filterable
            size="small"
            placeholder="请选择收货地区"
          >
          </el-cascader>
          <el-button
            :disabled="queryAreaCodeRegion.length === 0"
            size="small"
            type="text"
            class="blue"
            @click="addArea"
            >添加</el-button
          >
          <div v-if="areaList.regionCodeList.length">
            <el-table
              stripe
              border
              ref="table"
              :data="[areaList]"
              style="width: 100%"
              size="small"
              :show-header="true"
            >
              <el-table-column header-align="center" label="指定区">
                <template slot-scope="scope">
                  <el-tag
                    v-for="(v, i) in scope.row.regionCodeList"
                    :key="i"
                    closable
                    class="blue"
                    style="margin:5px"
                    @close="areaClose(i)"
                  >
                    {{ v.name }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                label="运费规则"
                width="800"
              >
                <template slot-scope="scope">
                  <div class="delive-content">
                    <div v-if="ruleForm.feeCalcMode === 'weight'">
                      <el-input
                        @mousewheel.prevent.native
                        clearable
                        style="width:100px;"
                        v-model="scope.row.lowerLimitNumber"
                        @input="filterGt0OrAreaFixed2('lowerLimitNumber')"
                        size="small"
                      ></el-input
                      >KG内,邮费<el-input
                        clearable
                        @mousewheel.prevent.native
                        style="width:100px;"
                        v-model="scope.row.lowerLimitAmount"
                        @input="filterGt0OrAreaFixed2('lowerLimitAmount')"
                        size="small"
                      ></el-input
                      >元,每增加<el-input
                        @mousewheel.prevent.native
                        clearable
                        style="width:100px;"
                        v-model="scope.row.overPerUnit"
                        @input="filterGt0OrAreaFixed2('overPerUnit')"
                        size="small"
                      ></el-input
                      >KG,运费增加<el-input
                        clearable
                        @mousewheel.prevent.native
                        style="width:100px;"
                        v-model="scope.row.overPerPrice"
                        @input="filterGt0OrAreaFixed2('overPerPrice')"
                        size="small"
                      ></el-input
                      >元
                    </div>
                    <!-- 按件数收费 -->
                    <div
                      v-if="ruleForm.feeCalcMode === 'number'"
                      style="marginBottom:5px"
                    >
                      <el-input
                        clearable
                        maxlength="8"
                        @mousewheel.prevent.native
                        style="width:100px;"
                        v-model="scope.row.lowerLimitNumber"
                        @input="filterGtArea0('lowerLimitNumber')"
                        size="small"
                      ></el-input
                      >件内,邮费<el-input
                        clearable
                        maxlength="8"
                        @mousewheel.prevent.native
                        style="width:100px;"
                        v-model="scope.row.lowerLimitAmount"
                        @input="filterGt0OrAreaFixed2('lowerLimitAmount')"
                        size="small"
                      ></el-input
                      >元,每增加<el-input
                        clearable
                        maxlength="8"
                        @mousewheel.prevent.native
                        style="width:100px;"
                        v-model="scope.row.overPerUnit"
                        @input="filterGtArea0('overPerUnit')"
                        size="small"
                      ></el-input
                      >件,运费增加<el-input
                        clearable
                        maxlength="8"
                        @mousewheel.prevent.native
                        style="width:100px;"
                        v-model="scope.row.overPerPrice"
                        @input="filterGt0OrAreaFixed2('overPerPrice')"
                        size="small"
                      ></el-input
                      >元.
                    </div>
                    满<el-input
                      clearable
                      maxlength="8"
                      @mousewheel.prevent.native
                      style="width:100px;"
                      v-model="scope.row.freeShipAmount"
                      @input="filterGt0OrAreaFixed2('freeShipAmount')"
                      size="small"
                    ></el-input
                    >元包邮.<span class="form-red">为空则不开启包邮！</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <!-- <el-form
        ref="areaRuleForm"
        :model="areaRuleForm"
        :rules="areaRules"
        label-width="110px"
        v-if="searchCondition.orderState === 'areaRuleForm'"
      >
        <el-form-item label="模板名称" prop="expressName">
          <el-input
            clearable
            v-model="areaRuleForm.expressName"
            size="small"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择配送区域" prop="expressName">
          <div class="flex flex-wrap">
            <el-tree
              empty-text="暂无权限"
              class="tree-style flex-1 flex-center"
              :props="props"
              node-key="value"
              ref="tree1"
              :load="loadNode1"
              lazy
              highlight-current
              show-checkbox
            ></el-tree>
            <el-tree
              empty-text="暂无权限"
              class="tree-style flex-1 flex-center"
              :props="props"
              node-key="value"
              ref="tree2"
              :load="loadNode2"
              lazy
              highlight-current
              show-checkbox
            ></el-tree>
            <el-tree
              empty-text="暂无权限"
              class="tree-style flex-1 flex-center"
              :props="props"
              node-key="value"
              ref="tree3"
              :load="loadNode3"
              lazy
              highlight-current
              show-checkbox
            ></el-tree>
          </div>
        </el-form-item>
      </el-form> -->
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="submitRuleForm('ruleForm')"
          >确 认</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-drawer
      custom-class="hm-drawer"
      :wrapperClosable="false"
      title="选择配送范围"
      :visible="authorizeDialogVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <div class="caption">所有的配送范围：</div>
        <el-input
          placeholder="输入关键字进行搜索"
          clearable
          v-model="filterText"
          size="small"
        >
        </el-input>
        <!-- <el-tree
          v-if="authorizeDialogVisible"
          empty-text="暂无权限"
          :props="props"
          node-key="value"
          ref="tree"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
          @check-change="handleCheckChange"
        ></el-tree> -->
        <div class="mt10" style="height:600px">
          <el-scrollbar style="height:100%" class="page-component__scroll">
            <el-tree
              v-if="authorizeDialogVisible"
              :data="copyArea"
              empty-text="暂无数据"
              :filter-node-method="filterNode"
              :props="props"
              node-key="code"
              ref="tree"
              show-checkbox
            ></el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="drawer-footer flex flex-between item-center">
        <div>
          <el-dropdown trigger="click" @command="selectItem">
            <span class="el-dropdown-link flex item-center">
              树操作
              <i class="el-icon-arrow-up el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                command="checkAll"
                :disabled="filterText.length > 0"
                >全部勾选</el-dropdown-item
              >
              <el-dropdown-item
                command="cancleCheckAll"
                :disabled="filterText.length > 0"
                >取消全选</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button type="primary" size="small" @click="savePermission"
            >保存</el-button
          >
          <el-button size="small" @click="authorizeDialogVisible = false"
            >返回</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :close-on-click-modal="false"
      title="删除提示"
      :visible.sync="dialogVisibleDel"
      width="700px"
    >
      <div slot="title">
        <span class="blue">{{ row.express }}</span> 删除提示!
      </div>
      <div class="flex flex-center">
        <span
          class="el-icon-warning"
          style="fontSize:40px;color:#fe7300"
        ></span>
      </div>
      <div class="flex flex-center mt20" style="fontSize:17px;">
        该运费模板已关联商品，是否确认删除？（删除后则使用“默认运费模板”）
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="delExpress"
          >确 认</el-button
        >
        <el-button size="small" @click="dialogVisibleDel = false"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import area from "@/utils/area";
export default {
  components: {},
  data() {
    const validatorRegionCode = (rule, val, callback) => {
      if (
        this.areaList.regionCodeList.length === 0 &&
        this.ruleForm.defaultFeeMode === "no"
      ) {
        return callback(new Error("如果默认运费关闭，请添加指定区域运费！"));
      } else if (this.areaList.regionCodeList.length) {
        let flag = false;
        let list = [this.areaList];
        list.forEach(v => {
          if (
            v.lowerLimitNumber === "" ||
            v.lowerLimitAmount === "" ||
            v.overPerUnit === "" ||
            v.overPerPrice === ""
          ) {
            flag = true;
          }
        });
        if (flag) {
          return callback(new Error("请填写完整运费！"));
        }
      }
      callback();
    };
    const validator = (rule, val, callback) => {
      if (
        this.ruleForm.templateRelModels.length === 0 &&
        this.ruleForm.defaultFeeMode === "no"
      ) {
        return callback(new Error("如果默认运费关闭，请选择指定区域运费！"));
      } else if (this.ruleForm.templateRelModels.length) {
        let flag = false;
        this.ruleForm.templateRelModels.forEach(v => {
          if (
            v.lowerLimitNumber === "" ||
            v.lowerLimitAmount === "" ||
            v.overPerUnit === "" ||
            v.overPerPrice === ""
          ) {
            flag = true;
          }
        });
        if (flag) {
          return callback(new Error("请填写完整运费！"));
        }
      }
      callback();
    };
    const validatorMode = (rule, val, callback) => {
      if (val === "yes") {
        if (
          this.ruleForm.lowerLimitNumber === "" ||
          this.ruleForm.lowerLimitExpressyFee === "" ||
          this.ruleForm.overPerUnit === "" ||
          this.ruleForm.overPerPrice === ""
        ) {
          return callback(new Error("请填写完整默认运费！"));
        }
      }
      callback();
    };
    return {
      queryAreaCodeRegion: [],
      areaList: {
        regionCodeList: [],
        lowerLimitNumber: "",
        lowerLimitAmount: "",
        overPerUnit: "",
        overPerPrice: "",
        freeShipAmount: ""
      },
      dialogVisibleDel: false,
      area: [],
      copyArea: [],
      props: {
        label: "name",
        children: "children"
      },
      authorizeDialogVisible: false,
      ruleForm: {
        expressName: "",
        // separateFeeMode: "no",
        feeCalcMode: "number",
        defaultFeeMode: "no",
        lowerLimitNumber: "",
        lowerLimitExpressyFee: "",
        overPerUnit: "",
        overPerPrice: "",
        freeShipAmount: "",
        templateRelModels: [],
        isArea: "no"
      },
      rules: {
        expressName: {
          required: true,
          message: "请输入模板名称",
          trigger: "blur"
        },
        separateFeeMode: {
          required: true,
          trigger: "blur"
        },
        feeCalcMode: {
          required: true,
          message: "请选择计价方式",
          trigger: "blur"
        },
        defaultFeeMode: {
          required: true,
          validator: validatorMode,
          trigger: "change"
        },
        defaultExpress: {
          required: true,
          validator: validator,
          trigger: "blur"
        },
        isArea: {
          required: true,
          validator: "指定选择运费模式",
          trigger: "blur"
        },
        regionCodeList: {
          required: true,
          validator: validatorRegionCode,
          trigger: "blur"
        }
      },
      changeOnSelect: false,
      area,
      queryProps: {
        checkStrictly: false,
        multiple: true,
        value: "value",
        label: "label",
        children: "children"
      },
      searchCondition: {},
      title: "",
      dialogVisible: false,
      feeCalcModeList2: [],
      checkList: [],
      allCheckList: {},
      areaRuleForm: {},
      areaRules: {},
      type: "",
      i: 0,
      filterText: "",
      list: [],
      row: {},
      listType: ""
    };
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {},
  mounted() {
    this.queryRegionCodeProvCity();
    this.queryFeeCalcModeList2();
    this.queryList();
  },
  methods: {
    isAreaChange(val) {
      if (val === "yes") {
        this.areaList = {
          regionCodeList: [],
          lowerLimitNumber: "",
          lowerLimitAmount: "",
          overPerUnit: "",
          overPerPrice: "",
          freeShipAmount: ""
        };
      } else {
        this.ruleForm.templateRelModels = [];
      }
    },
    areaClose(i) {
      this.areaList.regionCodeList.splice(i, 1);
    },
    addArea() {
      this.$refs.cascader.checkedNodes.forEach(v => {
        this.areaList.regionCodeList.push({
          name: v.data.label,
          value: v.data.value
        });
      });
      // let params = {
      //   name: this.$refs.cascader.inputValue,
      //   value: this.queryAreaCodeRegion[this.queryAreaCodeRegion.length - 1]
      // };
      // this.areaList.regionCodeList.push(params);
      this.areaList.regionCodeList = arrayUnique2(
        this.areaList.regionCodeList,
        "value"
      );
    },
    handleCloseaa() {
      this.dialogVisible = false;
      this.resetRuleForm();
    },
    remove(row) {
      this.row = row;
      row.operationType = "del";
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("checkSpuExpressRel", row).then(res => {
          if (res.result) {
            this.dialogVisibleDel = true;
          } else {
            this.delExpress();
          }
        });
        // this.$store.dispatch("editStoreExpressConfigNew", row).then(res => {
        //   if (res.code === "0") {
        //     this.$message({
        //       message: " 操作成功",
        //       type: "success"
        //     });
        //     this.queryList();
        //   }
        // });
      });
    },
    async delExpress() {
      const { code } = await this.$store.dispatch(
        "editStoreExpressConfigNew",
        this.row
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.dialogVisibleDel = false;
        this.queryList();
      }
    },
    async details(row) {
      this.row = row;
      const { result } = await this.$store.dispatch(
        "detailsStoreExpressConfigNew",
        { expressId: row.expressId }
      );
      this.listType = "edit";
      this.title = "编辑运费模板";
      this.dialogVisible = true;
      for (let key in result) {
        this.ruleForm[key] = result[key];
      }
      if (result.isArea === "yes") {
        for (let key in this.areaList) {
          this.areaList[key] = result.templateRelModels[0][key];
          this.areaList.regionCodeList.forEach(v => {
            v.value = v.code;
          });
        }
      } else {
        if (this.ruleForm.templateRelModels === null) {
          this.ruleForm.templateRelModels = [];
        } else {
          this.checkList = [];
          this.ruleForm.templateRelModels.forEach(v => {
            //   v.disableArea = JSON.parse(v.disableArea);
            v.disableCheck = JSON.parse(v.disableArea) || "";
            v.check = v.regionCodeList.map(o => o.code);
            v.areaCodeRegion = v.regionCodeList;

            this.checkList.push(...v.disableCheck);
          });

          // let disabled = [];
          // this.checkList.forEach(v => {
          //   if (row.check.findIndex(o => o == v) < 0) {
          //     disabled.push(v);
          //   }
          // });
          // this.checkDisabled(disabled);
        }
      }
    },
    async queryList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      const { result } = await this.$store.dispatch(
        "storeExpressConfigList",
        searchCondition
      );
      this.list = [];
      if (result.defaultTemplate) {
        this.list.push(result.defaultTemplate);
      }
      this.list.push(...result.templateList);
    },
    // defaultModeChange(val) {
    //   if (val === "no") {
    //   }
    // },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    async queryRegionCodeProvCity() {
      // 使用 area.js 的 CDN 数据
      const areaData = JSON.parse(JSON.stringify(area));

      // 1. area 保持 CDN 完整格式（省-市-区三级，value/label），供 el-cascader 使用
      const cascaderData = areaData.map(province => {
        const newProvince = {
          value: province.value,
          label: province.label,
          children: []
        };
        if (province.children && Array.isArray(province.children)) {
          newProvince.children = province.children.map(city => {
            const newCity = {
              value: city.value,
              label: city.label,
              children: []
            };
            // 保留区级数据
            if (city.children && Array.isArray(city.children)) {
              newCity.children = city.children.map(district => ({
                value: district.value,
                label: district.label
              }));
            }
            return newCity;
          });
        }
        return newProvince;
      });
      this.area = cascaderData;

      // 2. copyArea 转换为 code/name 格式，只保留省-市两级（过滤区级），供抽屉的 el-tree 使用
      const treeData = areaData.map(province => {
        const newProvince = {
          code: province.value,
          name: province.label,
          children: []
        };
        if (province.children && Array.isArray(province.children)) {
          newProvince.children = province.children.map(city => ({
            code: city.value,
            name: city.label
            // 不保留区级数据
          }));
        }
        return newProvince;
      });
      this.copyArea = treeData;
      console.log("[Tree Data] copyArea:", this.copyArea);
      console.log("[Tree Data] 第一个省份:", this.copyArea[0]);
    },
    handleClose() {
      this.authorizeDialogVisible = false;
    },
    del(i, row) {
      let list = [];

      this.checkList.forEach(v => {
        if (row.disableCheck.findIndex(o => o === v) < 0) {
          list.push(v);
        }
      });
      this.checkList = list;

      this.ruleForm.templateRelModels.splice(i, 1);
      if (this.ruleForm.templateRelModels.length == 0) {
        this.checkList = [];
      }
    },
    edit(row, i) {
      this.i = i;
      this.type = "edit";
      this.authorizeDialogVisible = true;
      // 将 area（value/label格式）转换为 copyArea（code/name格式）
      this.copyArea = JSON.parse(JSON.stringify(this.area)).map(province => {
        const newProvince = {
          code: province.value,
          name: province.label,
          children: []
        };
        if (province.children && Array.isArray(province.children)) {
          newProvince.children = province.children.map(city => ({
            code: city.value,
            name: city.label
          }));
        }
        return newProvince;
      });
      let disabled = [];
      //   this.checkList.forEach(v => {
      //     if (row.check.findIndex(o => o == v) < 0) {
      //       disabled.push(v);
      //     }
      //   });
      this.ruleForm.templateRelModels.forEach((v, index) => {
        if (index !== i) {
          disabled.push(...v.disableCheck);
        }
      });

      this.checkDisabled(disabled);
      setTimeout(() => {
        this.$refs.tree.setCheckedKeys(row.check);
      }, 1000);
    },

    getSimpleCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = function(node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;

        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push({ code: child.data.code, name: child.data.name });
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store);

      return checkedNodes;
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //   let areaCodeRegion = this.$refs.tree.getCheckedNodes();

          //   let arr = JSON.parse(JSON.stringify(areaCodeRegion));
          //   for (let i = 0; i < arr.length; i++) {
          //     for (let j = i + 1; j < arr.length; j++) {
          //       if (arr[j].value.indexOf(arr[i].value) > -1) {
          //         this.depTags = this.depTags.filter(item => {
          //           return item.value !== arr[j].value;
          //         });
          //       }
          //     }
          //   }
          let params = this.ruleForm;

          if (this.ruleForm.isArea === "yes") {
            this.areaList.regionCodeList.forEach(v => {
              v.code = v.value;
            });
            params.templateRelModels = [this.areaList];
          }

          let name =
            this.listType === "add"
              ? "saveStoreExpressConfigNew"
              : "editStoreExpressConfigNew";
          if (this.listType === "edit") {
            params.expressId = this.row.expressId;
            params.operationType = "edit";
          }

          this.$store.dispatch(name, params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.resetRuleForm();
              this.queryList();
              this.$message({
                message: "操作成功",
                type: "success"
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    unique(arr) {
      return Array.from(new Set(arr));
    },

    savePermission() {
      if (this.$refs.tree.getCheckedNodes().length) {
        let a = this.$refs.tree
          .getCheckedKeys()
          .concat(this.$refs.tree.getHalfCheckedKeys());
        // this.checkList.push(...a);

        this.checkList = [];
        if (this.type === "add") {
          this.ruleForm.templateRelModels.push({
            lowerLimitNumber: "",
            lowerLimitAmount: "",
            overPerPrice: "",
            overPerUnit: "",
            freeShipAmount: "",
            disableArea: JSON.stringify(a),
            disableCheck: a,
            regionCodeList: this.getSimpleCheckedNodes(this.$refs.tree.store),
            check: this.$refs.tree.getCheckedKeys(),
            areaCodeRegion: this.getSimpleCheckedNodes(this.$refs.tree.store)
          });
        } else {
          this.ruleForm.templateRelModels[this.i].disableCheck = a;
          this.ruleForm.templateRelModels[this.i].disableArea = JSON.stringify(
            a
          );
          this.ruleForm.templateRelModels[
            this.i
          ].regionCodeList = this.getSimpleCheckedNodes(this.$refs.tree.store);
          this.ruleForm.templateRelModels[
            this.i
          ].check = this.$refs.tree.getCheckedKeys();
          this.ruleForm.templateRelModels[
            this.i
          ].areaCodeRegion = this.getSimpleCheckedNodes(this.$refs.tree.store);
          //   this.ruleForm.templateRelModels[this.i] = {
          //     // lowerLimitNumber: "",
          //     // lowerLimitAmount: "",
          //     // overPerPrice: "",
          //     disableCheck: a,
          //     disableArea: JSON.stringify(a),
          //     regionCodeList: this.getSimpleCheckedNodes(this.$refs.tree.store),
          //     check: this.$refs.tree.getCheckedKeys(),
          //     areaCodeRegion: this.getSimpleCheckedNodes(this.$refs.tree.store)
          //   };
        }
        this.ruleForm.templateRelModels.map(o => {
          this.checkList.push(...o.disableCheck);
        });
        // this.checkList = this.checkList.filter(o => o.level !== "1");

        this.authorizeDialogVisible = false;
        this.copyArea = [];
      } else {
        this.$message({
          message: "请选择区域!",
          type: "warning"
        });
      }
    },
    selectItem(e) {
      let expand = false;

      switch (e) {
        case "checkAll":
          this.$refs.tree.setCheckedNodes(this.copyArea);
          break;
        case "cancleCheckAll":
          this.$refs.tree.setCheckedNodes([]);
          break;
        case "openAll":
          expand = true;
          break;
        case "cancleOpenAll":
          expand = false;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = expand;
      }
    },
    checkDisabled(checkList) {
      this.copyArea.forEach(v => {
        if (checkList.length) {
          if (checkList.findIndex(o => o == v.code) >= 0) {
            v.disabled = true;
          }
          v.children.findIndex(j => {
            if (checkList.findIndex(o => o == j.code) >= 0) {
              j.disabled = true;
            }
          });
        }
      });
      return this.data;
    },
    addChild() {
      this.type = "add";
      this.authorizeDialogVisible = true;
      // 将 area（value/label格式）转换为 copyArea（code/name格式）
      this.copyArea = JSON.parse(JSON.stringify(this.area)).map(province => {
        const newProvince = {
          code: province.value,
          name: province.label,
          children: []
        };
        if (province.children && Array.isArray(province.children)) {
          newProvince.children = province.children.map(city => ({
            code: city.value,
            name: city.label
          }));
        }
        return newProvince;
      });
      //   this.$refs.tree.setCheckedNodes([]);s
      if (this.checkList.length) {
        this.checkDisabled(this.checkList);
      }
    },
    feeCalcModeChange() {
      this.ruleForm.lowerLimitNumber = "";
      this.ruleForm.lowerLimitExpressyFee = "";
      this.ruleForm.overPerUnit = "";
      this.ruleForm.overPerPrice = "";
      if (this.ruleForm.templateRelModels.length) {
        this.ruleForm.templateRelModels.forEach(v => {
          v.lowerLimitNumber = "";
          v.lowerLimitAmount = "";
          v.overPerUnit = "";
          v.overPerPrice = "";
        });
      }
    },
    async queryFeeCalcModeList2() {
      const { result } = await this.$store.dispatch("queryFeeCalcModeList2");

      this.feeCalcModeList2 = result.filter(o => o.itemValue !== "gratis");
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addStoreExpress() {
      this.listType = "add";
      this.title = "新增运费模板";
      this.dialogVisible = true;
      this.expressDisabledList = [];
      this.resetRuleForm();
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "");

      // if (this.ruleForm[prop].length == 1) {
      //   this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      // } else {
      //   this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      // }
    },
    filterGt0OrArrayFixed2(i, prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleForm.templateRelModels[i][prop].indexOf(".") < 0 &&
        this.ruleForm.templateRelModels[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.templateRelModels[i][prop] = parseFloat(
          this.ruleForm.templateRelModels[i][prop]
        );
      }
    },
    filterGtArray0(i, prop) {
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm.templateRelModels[i][
        prop
      ] = this.ruleForm.templateRelModels[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      //   if (this.ruleForm.templateRelModels[prop].length == 1) {
      //     this.ruleForm.templateRelModels[prop] = this.ruleForm.templateRelModels[
      //       prop
      //     ].replace(/[^0-9]/g, "");
      //   } else {
      //     this.ruleForm.templateRelModels[prop] = this.ruleForm.templateRelModels[
      //       prop
      //     ].replace(/^(0+)|\D/g, "");
      //   }
    },
    filterGt0OrAreaFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.areaList[prop] = this.areaList[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.areaList[prop] = this.areaList[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.areaList[prop] = this.areaList[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.areaList[prop] = this.areaList[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.areaList[prop].indexOf(".") < 0 && this.areaList[prop] != "") {
        //首位是0的话去掉
        this.areaList[prop] = parseFloat(this.areaList[prop]);
      }
    },
    filterGtArea0(prop) {
      this.areaList[prop] = this.areaList[prop].replace(/^(0+)/, ""); //过滤0开头
      this.areaList[prop] = this.areaList[prop].replace(/^(0+)|[^\d]+/g, "");
      this.areaList[prop] = this.areaList[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      //   if (this.ruleForm.templateRelModels[prop].length == 1) {
      //     this.ruleForm.templateRelModels[prop] = this.ruleForm.templateRelModels[
      //       prop
      //     ].replace(/[^0-9]/g, "");
      //   } else {
      //     this.ruleForm.templateRelModels[prop] = this.ruleForm.templateRelModels[
      //       prop
      //     ].replace(/^(0+)|\D/g, "");
      //   }
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.row = {};
        this.i = 0;
        this.checkList = [];
        this.ruleForm.expressName = "";
        this.ruleForm.separateFeeMode = "no";
        this.ruleForm.feeCalcMode = "number";
        this.ruleForm.defaultFeeMode = "no";
        this.ruleForm.lowerLimitNumber = "";
        this.ruleForm.lowerLimitExpressyFee = "";
        this.ruleForm.overPerUnit = "";
        this.ruleForm.overPerPrice = "";
        this.ruleForm.freeShipAmount = "";
        this.ruleForm.isArea = "no";
        this.ruleForm.templateRelModels = [];
        this.areaList.regionCodeList = [];
        this.areaList.lowerLimitNumber = "";
        this.areaList.lowerLimitAmount = "";
        this.areaList.overPerUnit = "";
        this.areaList.overPerPrice = "";
        this.areaList.freeShipAmount = "";
        this.queryAreaCodeRegion = [];
      }, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.delive-box {
  border: 1px solid rgba(221, 221, 221, 1);
  .delive-heard {
    padding: 0 10px;
    background: rgba(247, 247, 247, 1);
  }
  .delive-content {
    padding: 10px;
  }
}
.table {
  border: 1px solid rgba(221, 221, 221, 1);
  .table-box {
    // border: 1px solid #222;
    .table-border {
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      padding: 0 10px;
      background: #f7f7f7;
      font-size: 14px;
      .expressName {
        font-weight: bold;
      }
    }
    .table-rule {
      //   height: 34px;
      line-height: 34px;
      font-weight: bold;
    }
    .table-content {
      font-size: 14px;
      font-weight: 400;
      line-height: 15px;
      font-family: PingFang SC;
      color: #222;
      padding: 20px 10px;
    }
  }
}
</style>
